/*
 *   File : listing.js
 *   Author : https://evoqins.com
 *   Description : Portfolio rebalance page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";

// Components
import { SectionTitle } from "../../Component/Title";
import { BreadCrumbs } from "../../Component/Other";
import { PrimaryButton, SecondaryButton } from "../../Component/Buttons";
import { CreateRebalance } from "../../Component/Modal";
import { _getOTP } from "../../Helper";

//Assets
import Loader from "../../Assets/Images/coloured_loader.svg";
import RebalanceArrow from "../../Assets/Images/rebalance-arrows.svg";
import { APIService } from "../../Service";


// custom data
const BREADCRUMBS = [
    {
        label: "Home",
        path: "/",
    },
    {
        label: "Portfolio rebalance",
    },
];

function PortfolioRebalance() {

    const navigate = useNavigate();
    const { state } = useLocation();

    const [rebalanceData, setRebalanceData] = useState(true);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [isAPILoading, setIsAPILoading] = useState(false);
    const [skipLoader, setSkipLoader] = useState(false);
    const [showRebalanceModal, setShowRebalanceModal] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" })
        _getRebalanceDetails();
    }, []);

    useEffect(() => {
        if (showRebalanceModal) {
            let modal = new Modal(document.getElementById('status-modal'));
            modal.show();
        }
    }, [showRebalanceModal]);

    const _handleRebalance = () => {
        setIsAPILoading(true);
        _getOTP({ type: "Rebalance" }).then((response) => {
            if (response.status_code === 200) {
                setShowRebalanceModal(true);
            } else {
                toast.dismiss();
                toast.error(response.message, { className: "e-toast" });
            }
        }).finally(() => {
            setIsAPILoading(false);
        });
    };

    const _handleSkipRebalance = () => {
        setSkipLoader(true);
        _skipRebalance();
    };

    const FundCard = ({ type, fundData }) => {
        return (
            <div className="col-md-5 flex-fill">
                <h6 className="e-text-bold-grey e-font-14-res e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px">
                    {type}
                </h6>
                <div className="d-flex gap-3 align-items-center">
                    <img src={fundData.fund_image}
                        width="40"
                        height="40"
                        class="col-auto object-fit-contain e-border-radius-8 border-seashell-blue-1px e-bg-white"
                        draggable="false" alt="fund logo" />
                    <p className="col-auto  flex-fill e-text-onyx e-font-14-res-lg e-font-16 e-primary-font-inter e-font-weight-500 line-height-20px mb-0">
                        {fundData.fund_name}
                    </p>
                    <span className="col-auto ms-auto e-text-onyx e-font-14-res-lg e-font-16 e-primary-font-inter e-font-weight-500 line-height-20px">
                        {fundData.percentage_display}
                    </span>
                </div>
            </div>
        )
    };


    //==================================== //
    //=========== API CAllS ============== //

    // Get rebalance details
    const _getRebalanceDetails = () => {
        let is_post = true;
        let api_version = 2;
        let url = 'rebalance/breakdown';
        let data = {
            "rebalance_id": state.rebalance_run_id
        };


        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setRebalanceData(response.data);
            } else {
                toast.dismiss();
                toast.error(response.message, { className: "e-toast" });
                navigate(-1);
            }
            setIsDataLoading(false);
        });
    };


    // SKIP Rebalance
    const _skipRebalance = () => {
        let is_post = true;
        let api_version = 2;
        let url = 'rebalance/consent';
        let data = {
            "skip": true,
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success("Rebalance skipped successfully", { className: "e-toast" });
                navigate(-1);
            } else {
                toast.dismiss();
                toast.error(response.message, { className: "e-toast" });
                skipLoader(false);
            }
        });
    };


    return (
        <div
            className="min-h-100vh pb-4 pb-sm-5 row ps-4 e-padding-24-right-res e-bg-lotion d-flex flex-column  padding-80px-right padding-26px-top e-border-radius-TL-BL-24px padding-246-bottom ">
            <BreadCrumbs data={BREADCRUMBS} />
            {

                isDataLoading ?
                    <div className="text-center mt-5" >
                        <img src={Loader}
                            draggable="false"
                            alt="loader" />
                    </div>
                    :
                    <section className="p-0  mt-4">
                        <SectionTitle title="Why is rebalancing required for investment portfolio right now?"
                            fontSize="e-font-20 e-font-18-res" className="padding-12px-bottom" />
                        <p className="e-text-bold-grey e-font-12-res e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px">
                            Rebalancing is important to reconcile your portfolio's asset allocation with your investing goals. Market swings may have caused specific assets to outperform or underperform, resulting in an imbalance in your portfolio's risk and return profile.
                        </p>
                        <span className={`e-border-1px-egyptian-blue  e-text-charleston-green e-bg-digital-lavender px-2 py-1 e-border-radius-18 e-font-10-res e-font-12 e-primary-font-inter e-font-weight-500`} >
                            Rebalance Issued On: {rebalanceData.rebalance_issued_date}
                        </span>

                        {/* Rebalance section */}
                        <section className="margin-top-32px">
                            <SectionTitle title="Rebalance breakdown"
                                fontSize="e-font-20 e-font-18-res" className="padding-10px-bottom" />

                            <div className="e-bg-cultured p-4 e-border-radius-16">
                                {/* Fund Changes */}
                                {
                                    rebalanceData.fund_changes?.funds.length !== 0 &&
                                    <>
                                        <div>
                                            <h4 className="e-text-onyx e-font-14-res e-font-16 e-primary-font-inter e-font-weight-500 line-height-20px margin-12px-bottom">
                                                {rebalanceData.fund_changes?.title}
                                            </h4>
                                            <p className="e-text-bold-grey e-font-12-res e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px">
                                                {rebalanceData.fund_changes?.description}
                                            </p>

                                            {/* Funds data */}
                                            <div className="d-flex flex-column row-gap-3">
                                                {
                                                    (rebalanceData.fund_changes?.funds || []).map((fund, index) => (
                                                        <div key={index} className="row flex-column row-gap-3 flex-md-row justify-content-md-between align-items-md-center">
                                                            <FundCard type={"Out"} fundData={fund.out} />
                                                            <div className="col-auto">
                                                                <img src={RebalanceArrow}
                                                                    width="20"
                                                                    height="20"
                                                                    className="margin-12px-lr mt-md-3 width-16px-res"
                                                                    draggable="false" alt="arrow" />
                                                            </div>
                                                            <FundCard type={"In"} fundData={fund.in} />
                                                            <hr className={`${index === 1 ? "d-none" : ""} d-block d-md-none e-border-1px-cool-light-gray mt-3 mb-0`} />
                                                        </div>
                                                    ))
                                                }
                                            </div>


                                        </div>
                                        <hr className="e-border-1px-cool-light-gray margin-24px-bottom-res margin-24px-top-res margin-top-40px margin-40px-bottom" />
                                    </>
                                }
                                {/* Allocation Changes */}
                                {
                                    rebalanceData.allocation_changes?.funds.length !== 0 &&
                                    <div>
                                        <h4 className="e-text-onyx e-font-14-res e-font-16 e-primary-font-inter e-font-weight-500 line-height-20px margin-12px-bottom">
                                          
                                            {rebalanceData.allocation_changes?.title}
                                        </h4>
                                        <p className="e-text-bold-grey e-font-12-res e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px">
                                            {rebalanceData.allocation_changes?.description}
                                        </p>

                                        <div className="d-flex flex-column row-gap-3">
                                            {
                                                (rebalanceData.allocation_changes?.funds || []).map((fund, index) => (
                                                    <div key={index} className="row flex-column row-gap-3 flex-md-row justify-content-md-between align-items-md-center">
                                                        <FundCard type={"Out"} fundData={fund.out} />
                                                        <div className="col-auto">
                                                            <img src={RebalanceArrow}
                                                                width="20"
                                                                height="20"
                                                                className="margin-12px-lr mt-md-3 width-16px-res"
                                                                draggable="false" alt="arrow" />
                                                        </div>
                                                        <FundCard type={"In"} fundData={fund.in} />
                                                        <hr className={`d-block d-md-none e-border-1px-cool-light-gray mt-3 mb-0`} />
                                                    </div>
                                                ))
                                            }
                                        </div>

                                    </div>
                                }

                                <div className="margin-top-40px  text-end">
                                    <SecondaryButton name="Skip"
                                        // type={2}
                                        loading={skipLoader}
                                        disabled={skipLoader}
                                        className="col-5 col-sm-3 col-xl-2 flex-fill padding-12px-tb e-bg-lotion e-font-14 e-text-charleston-green e-border-bright-gray me-2"
                                        onPress={_handleSkipRebalance} />
                                    <PrimaryButton name="Rebalance now"
                                        loading={isAPILoading}
                                        disabled={isAPILoading}
                                        className="col-6 col-sm-3 col-xl-2 padding-12px-tb flex-fill e-font-14"
                                        onPress={_handleRebalance} />
                                </div>
                            </div>

                        </section>
                    </section>
            }

            {
                showRebalanceModal &&
                <CreateRebalance onCloseModal={() => setShowRebalanceModal(false)} />
            }
        </div>
    )
}

export default PortfolioRebalance